import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { RequestNewFile, RequestQuickSubmit } from "../../../../../store/actions/dashboardActions";
import FileCardButton from "../../../../UI/FileCardButton/FileCardButton";
import TumerLight from "../../../../Icon-SVG/TumerLight";
import Warning from "../../../../common/Warning/Warning";
import { addNotification } from "../../../../../store/actions/notifierActions";

const Quick = ({ selectedFiles, setSelectedFiles }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [error, setError] = useState("");
  const licenceCheck = useSelector((state) => state?.users?.licenceCheck || {});
  const user = useSelector((state) => state?.users.user);
  const lastSubmitID = useSelector((state) => state?.dashboard.lastSubmitID);
  const submissionsLoading = useSelector((state) => state?.dashboard.submissionsLoading);

  const quickClickHandler = () => {
    if (licenceCheck.licenceStatus === "Unavailable") {
      dispatch(
        addNotification({
          message: "Your license key has expired. Please contact CyberFortress Technology Team.",
          options: { variant: "error" },
        }),
      );
    } else if (selectedFiles.length === 0) {
      setError("Please select at least one file");
      setShow(true);
    } else {
      const quickSubmitFiles = selectedFiles.map((data) => ({
        file: data.file,
        fileType: data?.file?.name.split(".").pop(),
        enforceSubmission: false,
      }));
      dispatch(RequestQuickSubmit(quickSubmitFiles));
      setSelectedFiles([]);
    }
  };

  // useEffect(() => {
  //   if (lastSubmitID) {
  //     if (
  //       licenceCheck?.theme === "cloud_model" ||
  //       user?.role !== "ADMIN" ||
  //       user?.role !== "SUPERADMIN"
  //     ) {
  //       const firstPart = lastSubmitID.split("(")[0];
  //       const result = `${firstPart}win10vpnfull_triage`;
  //       // history.push(`/analysis-reports?data=${result}`);
  //     }
  //   }
  // }, [lastSubmitID]);
  return (
    <FileCardButton onClick={quickClickHandler}>
      <TumerLight />
      <p>Quick</p>
      <Warning
        onClickOk={() => setShow(false)}
        show={show}
        setShow={setShow}
        text={error}
        article="Warning"
        cancelDisable={true}
        textOK="Okay"
      />
    </FileCardButton>
  );
};

export default Quick;
